import { Rl } from "api/questionService";

export function getRlLevel(rl: Rl|undefined): number {
    let level = 1;
    for (let l = 0; l < (rl?.questions.length ?? 0); l++) {
        if (rl?.questions[l].answers.every( answer => answer.answer === null ? false : answer.answer)) {
            level = rl?.questions[l].level;
        } else {
            break;
        }
    }
    return level;
}